import { SET_SEARCH_BAR_IN_HERO } from '../actions/search';

type State = {
  focused: boolean;
  visibleInHero: boolean;
};

type Action = {
  type: 'SEARCH_FOCUS' | 'SEARCH_BLUR' | 'SET_SEARCH_BAR_IN_HERO';
  state: boolean;
};

const initialState: State = {
  focused: false,
  visibleInHero: false,
};

export default function reducer(state = initialState, action: Action): State {
  if (!state) {
    return {
      ...initialState,
    };
  }

  switch (action.type) {
    case 'SEARCH_FOCUS': {
      return {
        ...state,
        focused: true,
      };
    }

    case 'SEARCH_BLUR': {
      return {
        ...state,
        focused: false,
      };
    }

    case SET_SEARCH_BAR_IN_HERO: {
      return {
        ...state,
        visibleInHero: action.state,
      };
    }
    default:
  }

  return state;
}
